import { observable } from "mobx";
import BindDataToStore from "../utils/BindDataToStore";

export default class Tour {
  id = null;

  @observable photos = [];

  @observable loading = false;

  constructor(data) {
    BindDataToStore(this, data);
  }
}
